import React from "react";
import videoc from "../../assets/video/tv-box.mp4";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Question() {

    return (
        <>
            <section className="container px-5 py-20">
                <div className="text-center mb-10"><h4
                    className="text-[32px] md:text-[35px] leading-[1.1em] font-medium">Preguntas frecuentes</h4>
                    <div className="mt-3 flex items-center gap-[5px] w-max mx-auto text-white">
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-10 h-1 rounded-xs"></div>
                    </div>
                    <p className="mt-4 mx-auto leading-relaxed text-white">Es posible que tenga algunas dudas sobre el
                        funcionamiento de Stella TV en una tv box, por ello abajo algunas respuestas a sus dudas más
                        frecuentes.
                    </p></div>
                <div className="mt-16 grid md:grid-cols-2 gap-[30px] px-[15px]">
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        descargar StellaTV en tv box?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">La forma más tradicional y funcional que tenemos ahora es
                                usando la aplicación de downloader. Sin embargo, existen otras aplicaciones que permiten
                                su descarga como: Send Files o Chrome.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Error
                        de StellaTV en TV Box?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">El error más común es que los canales no cargan o se
                                quedan congelados. Esto se debe mayormente a que la TV Box no soporta la app (es de gama
                                baja).</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Funciona
                        en todas las TV Box?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Por defecto todas las TV Box tienen sistema Android, lo
                                cual hace compatible la aplicación. Sin embargo, recomendamos siempre comprar TV Box de
                                gama alta con Android certificado.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        activar las fuentes desconocidas?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Este permiso es necesario tenerlo activado para poder
                                instalar apps no oficiales. Para activarlo vaya a
                                AJUSTES &gt; SEGURIDAD &gt; APLICACIONES (varía dependiendo de la versión de
                                Android).</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        instalar la app sin downloader?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Sí se puede. Recomendamos usar la aplicación Send Files
                                para pasar la app desde su móvil a su TV Box. También puede usar Google Chrome para
                                descargarla directamente.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Qué
                        versión de Android necesito?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Su TV Box mínimo debe tener la versión igual a Android
                                5.1 o superior. Si su TV Box tiene una versión menor es probable que no pueda instalar
                                la aplicación de Stella TV.</p></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Question;
